import { render, staticRenderFns } from "./depositFlowDetailModal.vue?vue&type=template&id=0fdb9902&scoped=true"
import script from "./depositFlowDetailModal.vue?vue&type=script&lang=js"
export * from "./depositFlowDetailModal.vue?vue&type=script&lang=js"
import style0 from "./depositFlowDetailModal.vue?vue&type=style&index=0&id=0fdb9902&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb9902",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fdb9902')) {
      api.createRecord('0fdb9902', component.options)
    } else {
      api.reload('0fdb9902', component.options)
    }
    module.hot.accept("./depositFlowDetailModal.vue?vue&type=template&id=0fdb9902&scoped=true", function () {
      api.rerender('0fdb9902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/depositFlowDetailModal.vue"
export default component.exports